import { CONTACT_REQUEST_API_BASE, V2_CLIENT_CODE_KEY } from '../Constants/APIConstantsV2';

const postContactRequest = (locationGuid, targetGuid, parameters) => {
    let url = new URL(`${CONTACT_REQUEST_API_BASE}${locationGuid}/service-request/${targetGuid}`);

    return fetch(url, {
        method: "post",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'x-functions-key': V2_CLIENT_CODE_KEY
        },
        body: JSON.stringify({ ...parameters })
    });
}

export default postContactRequest;
